'use client';

import { useEffect, useState } from 'react';

export function useShortcutsCheatsheet() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    function handleKey(e: KeyboardEvent) {
      if (e.key === '?' && !isInputTarget(e.target)) {
        e.preventDefault();
        setIsOpen((prev) => !prev);
      }
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  useEffect(() => {
    function handleShowEvent() {
      setIsOpen(true);
    }
    window.addEventListener('kontora:show-shortcuts', handleShowEvent);
    return () => window.removeEventListener('kontora:show-shortcuts', handleShowEvent);
  }, []);

  return { isOpen, close: () => setIsOpen(false), open: () => setIsOpen(true) };
}

function isInputTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable;
}
